function updateMeterwareHints() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const items = document.querySelectorAll('.qsc2-product-item');
      items.forEach((item, index) => {
        const cartItem = cart.items[index];
        if (!cartItem) return;

        // Alten Hinweis entfernen
        const old = item.querySelector('.meterware-hint');
        if (old) old.remove();

        // Nur bei Meterware
        if (!cartItem.unit_price_measurement || cartItem.unit_price_measurement.measured_type !== 'length') return;

        const qty = cartItem.quantity;
        const meter = (qty * 0.5).toFixed(1).replace('.', ',');
        const einheit = qty === 1 ? 'Einheit' : 'Einheiten';

        const hint = document.createElement('p');
        hint.className = 'meterware-hint';
        hint.style = 'font-size:12px;color:#888;margin:4px 0 0 0;white-space:nowrap;';
        hint.textContent = `${qty} ${einheit} = ${meter} m`;

        const qtyEl = item.querySelector('.qsc2-product-item__quantity');
        if (qtyEl) qtyEl.after(hint);
      });
    });
}

document.addEventListener('DOMContentLoaded', updateMeterwareHints);
document.addEventListener('cart:refresh', updateMeterwareHints);

const observer = new MutationObserver(() => updateMeterwareHints());
observer.observe(document.body, { childList: true, subtree: true });